module.exports = __webpack_public_path__ + "img/1.d2cf0f60.png";